import { render } from "./CreateSubService.vue?vue&type=template&id=a99dd066&scoped=true"
import script from "./CreateSubService.vue?vue&type=script&lang=js"
export * from "./CreateSubService.vue?vue&type=script&lang=js"

import "./CreateSubService.vue?vue&type=style&index=0&id=a99dd066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99dd066"]])

export default __exports__